import motor from "./motor-icon.png";
import selfRegulatory from "./self_regulatory-icon.png";
import cognitive from "./cognitive-icon.png";
import sensory from "./sensory-icon.png";
import interactive from "./interactive-icon.png";

// Indexados por activity_types.id. Los PNG ya traen el cuadrado azul de fondo,
// asi que se pintan sueltos, sin envoltorio con color.
const activityTypeIcons = {
  1: motor,
  2: selfRegulatory,
  3: cognitive,
  4: sensory,
  5: interactive,
};

export default activityTypeIcons;
